import { render, staticRenderFns } from "./ModalDeleteStakeholder.vue?vue&type=template&id=32f99f98"
import script from "./ModalDeleteStakeholder.vue?vue&type=script&lang=js"
export * from "./ModalDeleteStakeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports